import { useState } from "react";
// import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { resetForgotPassword } from "../../../actions/authAction";
import {
  showErrMsg,
  showSuccessMsg,
} from "../../0-ResuableComponents/utils/notification/Notification";
import {
  isLength,
  isMatch,
} from "../../0-ResuableComponents/utils/validation/Validation";
import ResetForgotPasswordForm from "./ResetForgotPasswordForm";
import { encryptPlaintext } from "../../0-ResuableComponents/security/cryptoFunctions";

const initialState = {
  password: "",
  cf_password: "",
  err: "",
  success: "",
};

const ResetForgotPassword = ({ history }) => {
  const [data, setData] = useState(initialState);

  const queryParams = new URLSearchParams(window.location.search);
  const token = queryParams.get("resetToken");
  // const { token } = useParams();

  const { password, cf_password, err, success } = data;

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value, err: "", success: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isLength(password))
      return setData({
        ...data,
        err: "Password must be at least 6 characters.",
        success: "",
      });

    if (!isMatch(password, cf_password))
      return setData({
        ...data,
        err: "Password did not match.",
        success: "",
      });

    // console.log("SEND DATA", { email });
    const encryptedPassword = encryptPlaintext(password);
    try {
      let res = await resetForgotPassword(token, encryptedPassword);
      if (res.data) {
        // console.log(res.data);
        toast.success(res.data.message);
        history.push("/");
      }
    } catch (err) {
      toast.error(err.response.data.errorMessage);
    }
  };

  return (
    <div
      id="layoutSidenav_content"
      style={{ marginLeft: "28%", marginTop: "4%" }}
    >
      <div className="container-fluid">
        <div className="row">
          <p>
            {err && showErrMsg(err)}
            {success && showSuccessMsg(success)}
          </p>
        </div>
        <div className="row">
          <ResetForgotPasswordForm
            password={password}
            cf_password={cf_password}
            handleSubmit={handleSubmit}
            handleChangeInput={handleChangeInput}
          />
        </div>
      </div>
    </div>
  );
};

export default ResetForgotPassword;
